import { API, baseClient } from "../index";

/**
 * Pantalla de la campana de propinas (sin sesión, por el token del enlace).
 * Sin `desde` devuelve el historial y el cursor; con `desde`, los toques nuevos.
 */
export const getPantallaCampana = (token, desde) => {
  return baseClient().get(`${API}/campana/pantalla/${encodeURIComponent(token)}`, {
    params: desde ? { desde } : {},
  });
};
